import React, { useState } from 'react'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

import './Contact.css'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function Contact() {
    const [Name, setName] = useState('')
    const [Email, setEmail] = useState('')
    const [Subject, setSubject] = useState('')
    const [Message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [isNameValid, setIsNameValid] = useState('#b5c00c')
    const [isEmailValid, setIsEmailValid] = useState('#b5c00c')
    const [openInvalid, setOpenInvalid] = React.useState(false);
    const [openValid, setOpenValid] = React.useState(false);
    const [openError, setOpenError] = React.useState(false);

    const handleOpenInvalid = () => setOpenInvalid(true);
    const handleOpenValid = () => setOpenValid(true);
    const handleOpenError = () => setOpenError(true);
    const handleCloseInvalid = () => setOpenInvalid(false);
    const handleCloseValid = () => setOpenValid(false);
    const handleCloseError = () => setOpenError(false);


    const nameValidator = "^[a-zA-Z.,?\\s]*$";
    const emailvalidator = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$";
    const changeNameHandler = (e) => {
        if (!e.target.value.match(nameValidator)) {
            setIsNameValid('#ed3737')
            setName(e.target.value)
        }
        else {
            setIsNameValid('#b5c00c')
            setName(e.target.value)
        }
    }
    const changeEmailHandler = (e) => {
        if (!e.target.value.match(emailvalidator)) {
            setIsEmailValid('#ed3737')
            setEmail(e.target.value)
        }
        else {
            setIsEmailValid('#b5c00c')
            setEmail(e.target.value)
        }
    }

    const submitHandler = async () => {
        if (isNameValid === '#ed3737' || isEmailValid === '#ed3737' || Subject.length <= 10 || Message.length <= 10) {
            handleOpenInvalid()
        }
        else {
            console.log(Name, Email, Subject, Message)
            setLoading(true)
            // let res = await fetch("http://localhost:3001/", {
            let res = await fetch("https://send-email-wwnr.onrender.com/", {
                method: "POST",
                body: JSON.stringify({
                    name: Name,
                    email: Email,
                    subject: Subject,
                    message: Message
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })

            let data = await res.json()
            console.log(data)

            if (data?.status === 200) {
                handleOpenValid()
                setEmail('')
                setName('')
                setSubject('')
                setMessage('')
            }
            else {
                handleOpenError()
            }
            setLoading(false)
        }
    }

    return (
        <div id='Contact' className='Page'>
            <div className='titlecontainer'>
                <h2>Contact</h2>
            </div>
            <div className='contact-section'>
                <div className='contact-locations'>
                    <div className='location contact-items' >
                        <div className='contact-icon' onClick={() => { window.open('https://www.google.com/maps/place/Greater+Sudbury,+ON/@46.5825128,-81.7384947,9z/data=!3m1!4b1!4m6!3m5!1s0x4d2eff36c6f132ed:0x668dd5b8879c8cf8!8m2!3d46.4917317!4d-80.993029!16zL20vMDF4NDJo?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D', '_blank') }}>
                            {/* <i class='bx bx-pin'></i> */}
                            <LocationOnOutlinedIcon />
                        </div>
                        <div className='contact-details'> Sudbury, Ontario, Canada</div>
                    </div>
                    <div className='email contact-items'>
                        <div className='contact-icon' onClick={() => { window.open('mailto:ronyparmar2107@gmail.com', '_blank') }}>
                            {/* <i class='bx bx-envelope' ></i> */}
                            <EmailOutlinedIcon />
                        </div>
                        <div className='contact-details' >ronyparmar2107@gmail.com</div>
                    </div>
                    <div className='call contact-items'>
                        <div className='contact-icon' onClick={() => { window.open('https://wa.me/+14379555119', '_blank') }}>
                            {/* <i class='bx bx-phone-call' ></i> */}
                            <ContactPhoneOutlinedIcon />
                        </div>
                        <div className='contact-details' >+1 (437)955-5119</div>
                    </div>
                </div>
                <div className='contact-form'>
                    <div className='Name-email'>
                        <input
                            className='name-input input'
                            type='text'
                            style={{ outlineColor: isNameValid }}
                            placeholder='Name'
                            value={Name}
                            onChange={changeNameHandler} />
                        <input className='email-input input'
                            type='email'
                            style={{ outlineColor: isEmailValid }}
                            placeholder='Email'
                            value={Email}
                            onChange={changeEmailHandler} />
                    </div>
                    <div className='Subject'>
                        <input className='input'
                            type='text'
                            placeholder='Subject'
                            value={Subject}
                            onChange={(e) => { setSubject(e.target.value.toUpperCase()) }} />
                    </div>
                    <div className='Message'>
                        <textarea type='textbox'
                            className='input'
                            placeholder='Message'
                            value={Message}
                            style={{ height: '30vh', fontFamily: 'sans-serif' }}
                            onChange={(e) => { setMessage(e.target.value) }} />
                    </div>
                    <div className='Form-Submit'>
                        {/* <button onClick={submitHandler}>Send Message</button> */}
                        <Button loading={loading} variant="outlined" onClick={submitHandler}>
                            Submit
                        </Button>
                        <Modal
                            open={openInvalid}
                            onClose={handleCloseInvalid}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Please Enter Valid Details
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    Check your name and email again. Make sure the subject and Message has more than 3 words
                                </Typography>
                            </Box>
                        </Modal>
                        <Modal
                            open={openValid}
                            onClose={handleCloseValid}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Mail Sent!
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    Dear User, your mail has been sent to Rony Parmar.
                                </Typography>
                            </Box>
                        </Modal>
                        <Modal
                            open={openError}
                            onClose={handleCloseError}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Mail Send Failed!
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    Something is not right at the moment, Try contacting via emailing on ronyparmar2107@gmail.com
                                </Typography>
                            </Box>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact